import React from 'react';
import FileBase64 from '../util/Input64';
import { Input, Icon, Tooltip, Button, Select, Breadcrumb, Popover } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import SERVER_URL from '../Global';

const { Option } = Select;

export class ModifyHr extends React.Component {
    constructor(props) {
        super(props);      
        let params = queryString.parse(this.props.location.search);

        this.state = {
            user: this.props.token,
            hr: [],
            hrCreated: false,
            hrName: '',
            hrSurname: null,
            hrId: params.hrId,
            hrSaved: true,
            hrLoaded: false,
            hrImage: null,
            imageType: null,  
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSurnameChange = this.handleSurnameChange.bind(this);    
        this.saveHr = this.saveHr.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.cancelEndDate = this.cancelEndDate.bind(this);

        document.title = "Polar - Peoples"
    }

    componentDidMount() {
        //hr
        fetch(
            `${SERVER_URL + 'api/hr/' + this.state.hrId + '?lang=en'}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                }
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) { 
                    this.setState({ hr: res.data, hrName: res.data.name, hrSurname: res.data.surname, hrLoaded: true, hrImage: res.data.portraitImage, imageType: res.data.imageType })
                }
            }
        )        
    }

    handleNameChange(event) {
        this.setState({ hrName: event.target.value, hrSaved: false });
        if (event.target.value.length === 0) {
            this.setState({ hrName: null })
        }
    }

    handleSurnameChange(event) {
        this.setState({ hrSurname: event.target.value, hrSaved: false });

        if (event.target.value.length === 0) {
            this.setState({ hrSurname: null })
        }
    }

    deleteImage() {
        fetch(
            `${SERVER_URL + 'api/hr/image/hard/' + this.state.hrId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
            }
        )

        this.setState({ hrImage: null })
    }

    saveHr() {
        if (this.state.hrImage.length != 0) {
            fetch(`${SERVER_URL + 'api/hr'}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`,
                },
                body: JSON.stringify({
                    'name': this.state.hrName,
                    'surname': this.state.hrSurname,
                    'hrid': this.state.hrId,
                    'PortraitImage': this.state.hrImage,
                    "imageType": this.state.imageType,
                    "Status": 1,
                })
            }).then(response => response.json())               
            this.setState({ hrSaved: true })           
        } else {
            fetch(`${SERVER_URL + 'api/hr'}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`,
                },
                body: JSON.stringify({
                    'name': this.state.hrName,
                    'surname': this.state.hrSurname,
                    'hrid': this.state.hrId,
                    "Status": 1,
                })
            }).then(response => response.json())
            this.setState({ hrSaved: true })
        }
    }

    getFiles(files) {
        if (files.length != 0) {
            this.setState({ hrImage: files.base64, imageType: files.type, hrSaved: false });
        } else {
            this.setState({ hrImage: '' });
        }
    }

    goBack() {
        return window.open("/hr/index", '_self');
    }

    cancelEndDate(hroId) {
        let hrs = this.state.hr
        hrs.brHrRoleOfficies.map((br, i) => {            
            if (br.hroId === hroId) {                
                this.state.hr.brHrRoleOfficies[i].EndDate == null
                br.endDate = null
                fetch(
                    `${SERVER_URL + "api/brHrRoleOffice"}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            "officeId": br.officeId,
                            "roleId": br.roleId,
                            "hrId": br.hrId,
                            "hroId": br.hroId,
                            "WorkingForHROId": br.workingForHROId,
                            "Status": br.status,
                            "StartDate": br.startValue,
                            "EndDate": null,
                            "isAdInterim": br.adInterim,
                            'title': br.hrTitle,
                            "showAddressWorkingFor": br.showAddress
                        })
                    })                
            }
        })
        this.setState({hr: hrs})
    }

    render() {

        let name = this.state.hrName !== null ? this.state.hrName : ''

        let surname = this.state.hrSurname !== null ? this.state.hrSurname : ''

        let allSavedBlock = <p>Everything is already Saved</p>

        let mandatoryNotMet = <p>One or more Mandatory Fields are empty</p>

        let mandatoryName = this.state.hrName != null && this.state.hrName != '' ? <Icon type="check-circle" /> : <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" /></Tooltip>

        let mandatorySurname = this.state.hrSurname !== null ? <Icon type="check-circle" /> : <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" /></Tooltip>  

        let hrSave = this.state.hrSaved ? <div className="saveButtonBox"><Popover content={allSavedBlock}><Button disabled className="saveButtonHrWizard" icon="save">Save Hr</Button></Popover></div> : this.state.hrName !== null && this.state.hrSurname !== null ? <div className="saveButtonBox"> <Button onClick={this.saveHr} className="saveButtonHrWizard" icon="save">Save Hr</Button></div> : <div className="saveButtonBox"><Popover content={mandatoryNotMet}><Button disabled onClick={this.saveHr} className="saveButtonHrWizard" icon="save">Save Hr</Button></Popover></div>

        let imageContent = <div><p className="fakeLink" style={{ display: 'block' }} onClick={this.deleteImage}><Icon style={{ color: 'red' }} type="close" /> Remove image</p><img className="popoverImage" src={'data:' + this.state.imageType + ';base64,' + this.state.hrImage} /></div>

        let iconImage = this.state.hrImage !== null && this.state.hrImage !== '' ? <Popover content={imageContent}><div style={{ backgroundImage: 'url(' + `${'data:' + this.state.imageType + ';base64,' + this.state.hrImage}` + ')' }} className="trueWizardImage"></div></Popover> : <div className="fakeWizardImage">{this.state.hrName.charAt(0)}</div>

        let nameSurname = !this.state.disabledHrDetails ?
            <div style={{ display: 'flex' }} className="nameSurnameBox">
                <Input autoComplete="new-password" value={name} className={"hrName contactText hrNameValidation"} allowClear={true} placeholder="Name" onChange={this.handleNameChange} />
                {mandatoryName}
                <Input autoComplete="new-password" value={surname} className="hrSurname contactText" allowClear={true} placeholder="Surname" onChange={this.handleSurnameChange} />
                {mandatorySurname}
            </div> : null

        let nameSurnameDetail =
            <div style={{ width: '48%'}}>
                <div style={{ width: '100%', display: 'inline-flex' }}>
                    <Tooltip placement="topLeft" title="Insert here the HR's name and surname">
                        <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Hr Details:</h4>
                    </Tooltip>
                </div>
                {nameSurname}
            </div>

        let roleNumber = !this.state.hrLoaded ? "" : this.state.hr.brHrRoleOfficies.length > 1 ? "Roles: " : "Role: "

        let roleList = this.state.hrLoaded ?  
            <div style={{ margin: '20px 0px 30px', display: 'inline-flex' }}>
                <p><b>{roleNumber}</b></p>
                <ul style={{ listStyle: 'none', paddingLeft:'0px' }}>
                    {this.state.hr.brHrRoleOfficies.map((el,i) => {
                        let linkToComp = <Link to={"/edit?id=" + el.office.company.companyId} >{el.office.company.name}</Link>
                        let prettyEndDate = el.endDate == null ? "" : el.endDate.substring(8, 10) + "-" + el.endDate.substring(5, 7) + "-" + el.endDate.substring(0, 4)
                        let endDate = el.endDate == null ? "" : <span>, Role ended on: {prettyEndDate} <Tooltip title="Cancel EndDate"><Button icon="close" style={{ padding: '0px', boxShadow: '0px 0px 0px 0px', border: '0px solid', marginLeft: '5px', marginTop:'-5px' }} onClick={() => this.cancelEndDate(el.hroId)}></Button></Tooltip></span>
                        return (
                            <li style={{ marginLeft: '10px' }} key={el.hroId}>{el.role.name} ({linkToComp}){endDate}</li>
                            )
                    })}
                </ul>
            </div> : ""

        let hrPhoto =
            <div style={{ width: '48%', marginLeft: '4%' }}>
                <div style={{ width: '100%', display: 'inline-flex' }}>
                    <Tooltip placement="topLeft" title="Insert here the HR's image">
                        <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Hr Image:</h4>
                    </Tooltip>
                </div>
                <div className="wizardInputs">
                    <FileBase64 onDone={this.getFiles.bind(this)} />
                    {iconImage}
                </div>
                <span id="wrongSize" className="warningWizard" >Warning, file size is too big (max 150 kb)</span>
                <span id="wrongExtension" className="warningWizard">Warning, only .png, .jpg, .jpeg and .svg accepted</span>
            </div>

        return (
            <Container fluid={true}>
                <Row className="justify-content-center">
                    <Col style={{ height: '100%' }} sm="12">
                        <Button className="backButt" icon="caret-left" onClick={this.goBack}></Button>
                        <Breadcrumb className="bread">                            
                            <Breadcrumb.Item>Edit HR</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>

                    <Row style={{ width: '100%' }}>
                        <Col style={{ minHeight: '50vh' }} sm='12'>
                            <div className="wizardFields wizardContacts" style={{ minHeight: '50vh' }}>
                                <div className="wizardBackground" style={{ height: 'inherit' }}>
                                    <div>
                                        <div className="modifyHrBox" style={{ width: '100%' }}>
                                            <h3 style={{ fontSize:'20px' }}>{name} {surname}</h3>
                                            {roleList}
                                            <div className={"modifyHr" + this.state.hrSaved}>
                                                <div style={{ display: 'inline-flex', width: '100%' }}>
                                                    {nameSurnameDetail}
                                                    {hrPhoto}
                                                </div>
                                                {hrSave}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row> 
                </Row>                
            </Container>            

            )
    }
}

export default ModifyHr;


// WEBPACK FOOTER //
// ./src/Modify/ModifyHr.js